import styles from "./ShowGallery.module.css";
import MiddleBlock from "../../components/MiddleBlock/MiddleBlock";
import { getApiErrorMessage, loadFullGallery } from "../../api/api";
import { useEffect, useState } from "react";
import Pagination from "../../components/elements/Pagination/Pagination";
import Lightbox from "../../components/elements/Lightbox/Lightbox";
import Loader from "../../components/elements/Loader/Loader";
import ApiNotice from "../../components/elements/ApiNotice/ApiNotice";
import EmptyState from "../../components/elements/EmptyState/EmptyState";

export default function ShowGallery() {
    const [displayedImages, setDisplayedImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 15;

    useEffect(() => {
        const fetchGallery = async () => {
            setLoading(true);
            setError(null);

            try {
                const offset = (page - 1) * itemsPerPage;
                const result = await loadFullGallery(itemsPerPage, offset);

                const galleryData = result?.data || [];
                const total = result?.total || galleryData.length;
                
                setDisplayedImages(galleryData);
                setTotalPages(Math.ceil(total / itemsPerPage));
                
                console.log(`✅ Pobrano ${galleryData.length} zdjęć z ${total} wszystkich`);
            } catch (err) {
                console.error('❌ Błąd pobierania galerii:', err);
                setError(getApiErrorMessage(err, 'Nie udało się pobrać galerii.'));
                setDisplayedImages([]);
                setTotalPages(1);
            } finally {
                setLoading(false);
            }
        };

        fetchGallery();
    }, [page, itemsPerPage]);

    useEffect(() => {
        const galleryElement = document.querySelector('.galleryContainer');
        if (galleryElement) {
            galleryElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [page]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    if (loading) return <Loader />
    if (error) return (
        <MiddleBlock>
            <ApiNotice type="error" title="Nie udało się wczytać galerii">{error}</ApiNotice>
        </MiddleBlock>
    );
    if (!displayedImages || displayedImages.length === 0) return (
        <MiddleBlock>
            <EmptyState type="gallery" title="Galeria jest jeszcze pusta">
                Zdjęcia pojawią się tutaj po ich opublikowaniu.
            </EmptyState>
        </MiddleBlock>
    );

    return (
        <MiddleBlock>
            <div className={styles.galleryContainer}>
                <Lightbox>
                    {displayedImages.map((picture) => (
                        <img 
                            key={picture.id || picture._id || Math.random()} 
                            src={picture.image_path} 
                            alt={picture.caption || 'Zdjęcie galerii'} 
                            className={styles.galeryBlockImg}
                        />
                    ))}
                </Lightbox>
            </div>
            
            {totalPages > 1 && (
                <div className={styles.paginationWrapper}>
                    <Pagination 
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        showInfo={true}
                        size="md"
                    />
                </div>
            )}
        </MiddleBlock>
    );
}
